<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M28 15h-3.06A9 9 0 0017 7.06V4a1 1 0 00-2 0v3.06A9 9 0 007.06 15H4a1 1 0 000 2h3.06A9 9 0 0015 24.94V28a1 1 0 002 0v-3.06A9 9 0 0024.94 17H28a1 1 0 000-2zm-12 8a7 7 0 117-7 7 7 0 01-7 7z"/></svg>